import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import DepartmentTable from '@app/components/apps/Departments/DepartmentTable';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { PlusOutlined } from '@ant-design/icons';

const AllDepartments: React.FC = () => {
  const { t } = useTranslation();
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  const handleCreateClick = () => {
    navigate('/add-department');
  };

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/departments',
            breadcrumbName: 'Departments',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Create Department',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Add Department
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons]);

  return (
    <>
      <PageTitle>{'Departments'}</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <DepartmentTable />
        </Col>
      </Row>
    </>
  );
};

export default AllDepartments;
